const STORAGE_KEY = 'llumi-dashboard:selected-clients'

/**
 * Reads the selected client boardIds from localStorage.
 * Falls back to selecting every known client (first run, or corrupted storage).
 */
export function loadSelectedClientIds(allBoardIds: string[]): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return new Set(allBoardIds)

    const parsed: unknown = JSON.parse(raw)
    if (!Array.isArray(parsed)) return new Set(allBoardIds)

    const known = new Set(allBoardIds)
    return new Set(parsed.filter((id): id is string => typeof id === 'string' && known.has(id)))
  } catch {
    return new Set(allBoardIds)
  }
}

export function saveSelectedClientIds(ids: Set<string>): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)))
  } catch {
    // localStorage unavailable (private mode, quota) — selection just won't persist.
  }
}
